var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeloraIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66026 12.7809C5.66026 12.7809 0.72345 4.86563 6.23533 2.10218C9.73217 0.579179 13.2741 1.67174 15.116 2.61529C15.3233 2.70891 15.5057 2.79363 15.6692 2.8696C16.9034 3.44307 17.0649 3.51812 18.7868 3.15809C23.0458 2.1945 27.4504 2.69555 30.6175 4.0097C34.5937 0.221023 43.5168 0.0431004 38.8212 9.68138C38.8212 9.68138 39.7031 10.6679 40.2574 11.4721C40.4054 11.8005 40.2031 12.0989 39.9833 12.423C39.7313 12.7948 39.4563 13.2003 39.6604 13.7238C39.9652 14.5054 40.4449 15.2705 40.996 16.1493C41.6905 17.2569 42.4983 18.5451 43.2122 20.275C44.4927 23.3777 42.6902 28.1771 40.9593 30.9625C37.9944 35.5218 33.0847 33.7058 29.0569 31.7408C28.4876 31.4631 27.7987 31.7169 27.5593 32.2998L25.415 37.5226C25.0749 38.3508 24.1964 38.8353 23.3298 38.5895C17.2244 36.8579 6.84715 30.7486 1.49242 17.6755C1.09816 16.713 1.61675 15.6261 2.54417 15.1437C3.57436 14.608 4.83783 13.8063 5.66026 12.7809ZM40.4126 9.46281C40.7053 9.81498 41.0762 10.2786 41.3757 10.7131L41.4445 10.8129L41.4942 10.9232C41.7727 11.5412 41.6592 12.1128 41.4936 12.5041C41.3748 12.7848 41.1875 13.0577 41.0945 13.1931C41.0818 13.2117 41.0708 13.2276 41.062 13.2407C41.0249 13.2959 40.9978 13.3391 40.9781 13.372C41.2356 13.9837 41.6247 14.6053 42.152 15.4476C42.2211 15.5581 42.2927 15.6724 42.3666 15.7909C43.0204 16.8394 43.7829 18.1103 44.466 19.7655C45.2703 21.7143 45.0615 24.0321 44.5264 26.0759C43.9815 28.1566 43.04 30.1757 42.1125 31.6682L42.1052 31.6799L42.0977 31.6915C41.2369 33.0153 40.1901 33.9394 38.9933 34.4998C37.8031 35.0571 36.5478 35.2157 35.3226 35.1401C33.023 34.9982 30.6753 34.0162 28.7071 33.0676L26.6697 38.0298C26.0992 39.4194 24.5637 40.3378 22.9574 39.8822C16.5108 38.0538 5.77065 31.691 0.237255 18.1817C-0.469183 16.457 0.493697 14.6922 1.91524 13.9529C2.62901 13.5817 3.38764 13.1103 3.99614 12.5701C3.91936 12.4213 3.83708 12.2569 3.75166 12.0789C3.35027 11.2422 2.86347 10.0711 2.56123 8.78265C2.26216 7.50768 2.11837 6.01168 2.51346 4.5812C2.9246 3.09258 3.89677 1.76833 5.62434 0.902192L5.65714 0.885744L5.6908 0.871086C9.70264 -0.87622 13.6841 0.376632 15.707 1.40505C15.9376 1.50937 16.1134 1.59126 16.264 1.66144C16.4298 1.73865 16.5652 1.8017 16.7095 1.86486C16.9527 1.97124 17.0641 2.00479 17.1413 2.01958C17.2845 2.04699 17.4952 2.05381 18.4968 1.84474C22.683 0.900046 27.0069 1.27663 30.3454 2.46369C31.3867 1.64491 32.6115 1.02732 33.8431 0.655827C35.3322 0.206647 36.9715 0.0767641 38.388 0.531151C39.8887 1.01251 41.075 2.1438 41.4118 3.95187C41.6923 5.45778 41.358 7.29679 40.4126 9.46281Z",
    fill: "url(#paint0_linear_5488_14396)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0663 4.54289C32.914 3.78461 35.6348 2.41543 37.7045 3.13841C35.0735 3.26092 34.4143 5.80617 32.0663 4.54289Z",
    fill: "url(#paint1_linear_5488_14396)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78532 18.0764C5.37186 16.6812 4.32985 15.2624 2.58065 16.6771C6.15397 25.9463 12.4839 30.8878 12.4839 30.8878C9.11356 27.3778 6.91794 21.4115 5.78532 18.0764Z",
    fill: "url(#paint2_linear_5488_14396)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5764 24.4459C22.3204 25.9645 25.5982 26.066 30.5329 25.8705C28.2893 27.111 24.6322 27.0702 24.6322 27.0702C26.284 28.1799 29.6758 29.4722 33.17 29.6566C36.6642 29.841 39.229 28.9189 39.2237 25.7864C39.2237 22.5187 33.4979 18.8885 20.5764 24.4459Z",
    fill: "url(#paint3_linear_5488_14396)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3868 22.4401C41.6891 22.9244 40.8995 24.1556 40.6579 25.6663C39.6087 31.8147 42.8852 25.7322 42.3868 22.4401Z",
    fill: "url(#paint4_linear_5488_14396)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6606 30.2835C32.3734 31.7135 37.7805 34.1399 39.9274 30.0709L39.7664 29.9051C39.6847 29.8208 39.5579 29.7989 39.4509 29.8481C37.1491 30.9056 33.6727 31.2713 29.6606 30.2835Z",
    fill: "url(#paint5_linear_5488_14396)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7595 14.2281C32.3953 15.9695 33.1873 17.9797 33.8841 19.2772C34.2726 20.0005 35.0231 20.414 35.8436 20.5082C39.4057 20.917 40.5224 20.5888 41.2242 20.2713C41.5411 20.1279 41.7132 19.773 41.5193 19.4858C41.5193 19.4858 38.7557 14.9197 37.3894 13.1396C36.6402 12.0518 35.7511 10.9273 38.1432 10.9698C31.5135 4.1627 25.4427 3.07132 18.3859 4.60737C17.0137 4.87495 16.2646 4.67873 14.8444 3.97111C13.3283 3.20999 11.1711 2.34778 8.38464 2.83534C10.3673 4.12042 12.0103 6.14099 13.1588 7.90386C14.6001 10.1163 17.0439 11.7413 19.6914 11.5459L26.6103 11.0353C28.7692 10.876 31.022 12.2084 31.7595 14.2281Z",
    fill: "url(#paint6_linear_5488_14396)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3994 12.7023L17.1532 13.0153C7.04402 13.7614 12.1048 24.9872 24.4281 21.6331C31.1069 19.8153 32.1777 18.6114 30.7624 15.3763C30.5459 14.9896 30.1146 14.7699 29.6691 14.787C26.3688 14.9134 24.4986 14.1223 23.7756 13.3876C23.4066 13.0126 22.9266 12.6709 22.3994 12.7023Z",
    fill: "url(#paint7_linear_5488_14396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5488_14396",
    x1: 41.5,
    y1: -2.5,
    x2: 17,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5488_14396",
    x1: 41.5,
    y1: -2.5,
    x2: 17,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5488_14396",
    x1: 41.5,
    y1: -2.5,
    x2: 17,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5488_14396",
    x1: 41.5,
    y1: -2.5,
    x2: 17,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5488_14396",
    x1: 41.5,
    y1: -2.5,
    x2: 17,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5488_14396",
    x1: 41.5,
    y1: -2.5,
    x2: 17,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5488_14396",
    x1: 41.5,
    y1: -2.5,
    x2: 17,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5488_14396",
    x1: 41.5,
    y1: -2.5,
    x2: 17,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeloraIconDark);
export default __webpack_public_path__ + "static/media/velora_icon-dark.aa3222fec670380a9951e71e5dc0f2fb.svg";
export { ForwardRef as ReactComponent };